const paths = {
  homePage: "/",
  storyPage: "/story",
  philosophyPage: "/philosophy",
  approachPage: "/approach",
  expertisePage: "/expertise",
  founderPage: "/founder",
  contactPage: "/contact",
};

export default paths;
